import React from 'react';
import Box from '@material-ui/core/Box';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { CircularProgress, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    percentProgressRoot: {
        position: 'absolute',
        left: 0,
        top: 0,
        zIndex: 9999,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
}));

const PageLoadPercent = (props) => {
    const classes = useStyles();

    return (
        <Box className={classes.percentProgressRoot} style={{backgroundColor : "#ffffffa6"}}>
            <h3 style={{ marginBottom : 5}} id='title-scan'>Đang nâng cấp ứng dụng</h3>
            <Box position="relative" display="inline-flex">
                
                <CircularProgress variant="determinate" {...props} />
                <Box
                    top={0}
                    left={0}
                    bottom={0}
                    right={0}
                    position="absolute"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Typography variant="caption" component="div" color="textSecondary">{`${Math.round(
                        props.value,
                    )}%`}</Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default PageLoadPercent;
